import axios from 'axios';

interface AiResponse {
  response: string;
  sessionId: string;
}

const url: string = 
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_PROD_URL || ''
    : process.env.REACT_APP_API_URL || '';

export const getAiResponse = async (
  message: string,
  sessionId?: string
): Promise<{ response: string; sessionId: string }> => {
  try {
    const response = await axios.post<AiResponse>(url + "/ask/text", {
      message,
      sessionId
    });
    return response.data;
  } catch (error: any) {
    console.error('Fehler beim Abrufen der Antwort:', error);
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw new Error('Fehler beim Abrufen der Antwort');
  }
};

export const getAiResponseWithImageAsInput = async (
  message: string, 
  image: string,
  sessionId?: string
): Promise<{ response: string; sessionId: string }> => {
  try {
    const response = await axios.post<AiResponse>(url + '/ask/image', { 
      message, 
      image,
      sessionId 
    });
    return response.data;
  } catch (error: any) {
    console.error('Fehler beim Abrufen der Antwort mit Bild:', error);
    if (error.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw new Error('Fehler beim Abrufen der Antwort mit Bild');
  }
};